import classNames from 'classnames';
import React from 'react';
import ReactPlayer from 'react-player';

export interface YoutubeVideProps {
  video_id: string;
  autoplay: boolean;
  videoIsPlaying?: boolean;
  loop?: boolean;
  isBackground?: boolean;
}

const YoutubeVideo: React.FC<YoutubeVideProps> = ({
  video_id,
  autoplay,
  videoIsPlaying = false,
  loop = false,
  isBackground = false,
}) => {
  if (!video_id) return null;

  const config = {
    youtube: {
      // playsinline keeps the video embedded on mobile (iOS in particular)
      // instead of forcing fullscreen, so background videos autoplay inline.
      playerVars: { showinfo: 0, disablekb: 1, playsinline: 1 },
    },
  };

  return (
    <div
      className={classNames({
        'absolute top-1/2 left-1/2 h-[max(100%,56.25vw)] w-auto aspect-[16/9] -translate-x-1/2 -translate-y-1/2 overflow-hidden':
          isBackground,
        'w-full h-full': !isBackground,
        'pointer-events-none': autoplay,
      })}
    >
      <ReactPlayer
        url={`https://www.youtube.com/watch?v=${video_id}`}
        width="100%"
        height="100%"
        config={config}
        playing={autoplay ? true : videoIsPlaying}
        loop={loop}
        muted={autoplay}
        controls={!autoplay}
        // className="!absolute !top-0 !left-0"
        // style={{ position: 'absolute', top: 0, left: 0 }}
      />
    </div>
  );
};

export default YoutubeVideo;
